import { createAction, props } from '@ngrx/store';
import { ErrorResponse, IGenericError } from 'src/app/core/models/generic-models';
import { IEditUserRoleRequest } from '../models/edit-user-role.model';

export const loadEditUserRoles = createAction('[EditUserRole] Load EditUserRoles', props<{ request: IEditUserRoleRequest }>());

export const loadEditUserRolesSuccess = createAction('[EditUserRole] Load EditUserRoles Success', props<{ response: string }>());

export const loadEditUserRolesFailure = createAction(
  '[EditUserRole] Load EditUserRoles Failure',
  props<{ error: IGenericError<ErrorResponse> }>()
);
